/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Polling_Dns_PropagationInputs */

const en_polling_dns_propagation = /** @type {(inputs: Polling_Dns_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polling DNS propagation...`)
};

const es_polling_dns_propagation = /** @type {(inputs: Polling_Dns_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultando propagación DNS...`)
};

const fr_polling_dns_propagation = /** @type {(inputs: Polling_Dns_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification de la propagation DNS...`)
};

const de_polling_dns_propagation = /** @type {(inputs: Polling_Dns_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNS-Verbreitung wird abgefragt...`)
};

const ja_polling_dns_propagation = /** @type {(inputs: Polling_Dns_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNSの伝播をポーリング中...`)
};

const zh_polling_dns_propagation = /** @type {(inputs: Polling_Dns_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在轮询 DNS 解析状态...`)
};

const ar_polling_dns_propagation = /** @type {(inputs: Polling_Dns_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري استطلاع انتشار DNS...`)
};

const id_polling_dns_propagation = /** @type {(inputs: Polling_Dns_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memeriksa propagasi DNS...`)
};

const it_polling_dns_propagation = /** @type {(inputs: Polling_Dns_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica propagazione DNS in corso...`)
};

const ru_polling_dns_propagation = /** @type {(inputs: Polling_Dns_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опрос обновления DNS...`)
};

const pt_polling_dns_propagation = /** @type {(inputs: Polling_Dns_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisando propagação de DNS...`)
};

const ko_polling_dns_propagation = /** @type {(inputs: Polling_Dns_PropagationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNS 전파 확인 중...`)
};

/**
* | output |
* | --- |
* | "Polling DNS propagation..." |
*
* @param {Polling_Dns_PropagationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const polling_dns_propagation = /** @type {((inputs?: Polling_Dns_PropagationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Polling_Dns_PropagationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_polling_dns_propagation(inputs)
	if (locale === "es") return es_polling_dns_propagation(inputs)
	if (locale === "fr") return fr_polling_dns_propagation(inputs)
	if (locale === "de") return de_polling_dns_propagation(inputs)
	if (locale === "ja") return ja_polling_dns_propagation(inputs)
	if (locale === "zh") return zh_polling_dns_propagation(inputs)
	if (locale === "ar") return ar_polling_dns_propagation(inputs)
	if (locale === "id") return id_polling_dns_propagation(inputs)
	if (locale === "it") return it_polling_dns_propagation(inputs)
	if (locale === "ru") return ru_polling_dns_propagation(inputs)
	if (locale === "pt") return pt_polling_dns_propagation(inputs)
	return ko_polling_dns_propagation(inputs)
});